import { TableColumn, TableRow } from '@/components/Table/types';
import {
  dateColumnConfig,
  nameWithAvatarColumnConfig,
  rateColumnConfig,
  userToggleStatusColumnConfig,
} from '@/utils';
import { accessColumnConfig } from '@/utils/tableColumns/access-column.config';
import { actionsEditRowColumnConfig } from '@/utils/tableColumns/actions-edit-row-column-config';
import { emailColumnConfig } from '@/utils/tableColumns/email-column-config';
import { EntityTypes } from '../../types/users-csv-import-company-model';
import { t } from 'i18next';

type UsersColumnsConfig = {
  onNameClick?: (row: TableRow) => void;
  onEditClick?: (row: TableRow) => void;
  onAccessChange: (checked: boolean, row: TableRow) => void;
  onStatusChange: (checked: boolean, row: TableRow) => void;
};

export const getUsersColumns = ({
  onNameClick,
  onAccessChange,
  onStatusChange,
}: UsersColumnsConfig): Array<TableColumn<TableRow>> => {
  return [
    nameWithAvatarColumnConfig({ onClick: onNameClick }),
    emailColumnConfig(),
    accessColumnConfig({
      onChange: onAccessChange,
    }),
    userToggleStatusColumnConfig({
      onChange: onStatusChange,
    }),
  ];
};
export const getUsersColumnsNamedMapped = (columnName: string) => {
  const organizationsColumnsNamedMapped: Record<string, string> = {
    id: 'Id',
    name: 'FullName',
    email: 'Email',
    status: 'Status',
    access: 'Access',
  };

  return organizationsColumnsNamedMapped[columnName] ?? 'FullName';
};

export const getEntityType = (data: {
  organizationId?: number;
  companyId?: number;
  businessAreaId?: number;
  taskId?: number;
}): EntityTypes | null => {
  if (data.businessAreaId) {
    return EntityTypes.BusinessArea;
  }
  if (data.companyId) {
    return EntityTypes.Company;
  }
  if (data.taskId) {
    return EntityTypes.Task;
  }
  if (data.organizationId) {
    return EntityTypes.Organization;
  }
  return null;
};

export const getUserRatesColumns = ({
  onClick,
  columnsToEdit,
}: {
  onClick: (row: number) => void;
  columnsToEdit?: number[];
}): Array<TableColumn<TableRow>> => {
  return [
    rateColumnConfig(),
    dateColumnConfig({ key: 'startDate' }, 'start_date'),
    dateColumnConfig({ key: 'endDate' }, 'end_date', t('on_going')),
    actionsEditRowColumnConfig({
      onEditClick(row) {
        onClick(row.id as number);
      },
      canEdit: (row) => !!columnsToEdit?.includes(row.id as number),
    }),
  ];
};
